"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import copy from "clipboard-copy";
import "../../../contents/scss/clipBoard.scss";
import { CopyToClipboardSVG } from "../../../contents/svgs/common";
const CopyToClipboard = t0 => {
  const $ = _c(5);
  const {
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? true : t1;
  const notify = _temp;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const url = window?.location?.href;
      copy(url).then(notify).catch(_temp2);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleCopyClick = t2;
  const t3 = isMobile ? "t-flex t-flex-col" : "t-hidden sm:t-flex";
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <button className="t-block" aria-label="Share Icon" onClick={() => handleCopyClick()}><CopyToClipboardSVG fillColor="black" /></button>;
    t5 = <span className="bt-sp sm:t-hidden">Copy</span>;
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t3) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[3] = t3;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  return t6;
};
export default CopyToClipboard;
function _temp() {
  alert("Link copied to clipboard!");
}
function _temp2(err) {
  console.error("Copy to clipboard failed:", err);
}